import { useTranslation } from "../../../../i18n";
import { useMemo } from "react";
import { InspectionResult } from "../../../../__generated__/types-and-hooks";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

export function useInspectionResultOptions() {
  const t = useTranslation();
  const inspectionResultOptions = useMemo(
    () => [
      {
        label: t("Pass"),
        description: t("The inspection has passed"),
        value: InspectionResult.Pass,
        icon: <CheckCircleIcon color="success" />,
      },
      {
        label: t("Fail"),
        description: t("The inspection failed"),
        value: InspectionResult.Fail,
        icon: <CancelIcon color="error" />,
      },
      {
        label: t("Inconclusive"),
        description: t("The inspection is inconclusive"),
        value: InspectionResult.Inconclusive,
        icon: <HelpOutlineIcon color="warning" />,
      },
    ],
    [t]
  );
  return inspectionResultOptions;
}
